import { ChangeOpacityMessage } from 'game-ui-types'

import { BUY_BONUS_BUTTON_OPACITY_MESSAGE, restoreBuyBonusButtonInteractivity } from '@utils/featureReset'
import useMessageData from './useMessage'

/**
 * Keeps the Buy Bonus button clickable while it stays toggled between rounds.
 * See `restoreBuyBonusButtonInteractivity` for the case this recovers from.
 */
const useBuyBonusButtonRecovery = () => {
    useMessageData((data) => {
        if (data?.type !== BUY_BONUS_BUTTON_OPACITY_MESSAGE) return

        restoreBuyBonusButtonInteractivity((data as ChangeOpacityMessage).payload)
    }, [])
}

export default useBuyBonusButtonRecovery
